<template>
  <div class="rating-field radio-group">
    <div class="label">{{ label }}</div>
    <div class="group">
      <div
        v-for="(v, index) in values"
        :key="v"
        class="element radio custom-control custom-radio"
        :class="{last: index === values.length - 1}"
      >
        <input
          type="radio"
          :name="name"
          :id="`${name}_${v}`"
          :value="v"
          :checked="selected == v"
          class="custom-control-input"
        />
        <label :for="`${name}_${v}`" class="custom-control-label" v-html="numberLabel(v)" />
      </div>
        <div class="d-flex justify-content-between rating-text">
            <div>{{ minText }}</div>
            <div>{{ maxText }}</div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    name: { type: String, required: true },
    value: { type: Number, default: null },
    min: { type: Number, default: 1 },
    max: { type: Number, default: 7 },
    minText: { type: String, default: "Strongly Disagree" },
    maxText: { type: String, default: "Strongly Agree" },
  },
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    values() {
      var values = [];
      for (var n = this.min; n <= this.max; n++) {
        values.push(n);
      }
      return values;
    },
  },
  methods: {
      numberLabel(num) {
          return `<span>${num}</span>`;
      }
  },
  watch: {
    value(val) {
      this.selected = val;
    },
    selected(val) {
      this.$emit("input", val);
    },
  },
};
</script>